<template>
  <div class="seomain">
		<st-header
		  title="入库记录"
		  :back-able="true"
		>
		  <template slot="header-right">
				<span class="search-icon-span">
					<van-icon name="search" @click="showSearch = true"/>
				</span>
		  </template>
		</st-header>
   
    <div class="tab-content tab-content-list">
			<!-- 搜索 多行 -->
			<div class="keyword">
			  <van-form class="keyword-form" @submit="submitKeyword" v-if="showSearch">
			    <van-field v-model="searchData.batch" label="批次号" placeholder="请输入批次号" />
					<div style="background-color: white;">
						<div style="width: 97px;display: inline-block;padding-left: 15px;">采购单号</div>
						<div style="display: inline-block;width: calc(100% - 97px);">
							<st-select
								v-model="searchData.purchase_order_id"
								name="采购单号"
								placeholder="请选择采购单号"
								:options="$option['getPurchaseOrder']"
								:readonly="false"
								:clearable="true"
							>
							</st-select>
						</div>
					</div>
					 
			    <div :style="{ padding: '16px', backgroundColor: '#fff' }">
			      <van-button round block type="info" native-type="submit">搜 索</van-button>
			    </div>
			  </van-form>
        <div class="keyword-collapsed" v-else @click="showSearch = true">
          <van-icon name="search" />
          <span>展开搜索</span>
        </div>
				<div class="keyword-toggle-wrap">
					<div class="keyword-toggle-line">
						<span @click="showSearch = !showSearch" class="keyword-toggle-btn">
							<van-icon :name="showSearch ? 'arrow-up' : 'arrow-down'" />
						</span>
					</div>
				</div>
			</div>
			
      <div class="st-list-box pan-0">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list" v-for="(v, k) in stlist" :key="v.id" :index="k">
            <router-link :to="getDetailRoute(v)" class="st-list-top">
              <div class="t-tit">{{ v.purchase_order }}</div>
              <div class="t-status"></div>
            </router-link>
            <div class="st-list-main">
              <p class="field-row"><span class="field-label">批次号</span><span class="field-value">{{ v.batch }}</span></p>
              <p class="field-row"><span class="field-label">SKU</span><span class="field-value">-</span></p>
							<div :class="skuShowAll[v.id] ? '' : 'sku-show-part'">
								<div class="sku-list-box" v-for="(vv, i) in v.list" :key="vv.id || i">
									<div class="sku-info">
										<div class="sku-text">{{ vv.sku }}</div>
										<div class="sku-warehouse">{{ vv.warehouse }}</div>
									</div>
									<div class="outstocknum">{{ vv.storage }}</div>
								</div>
								<div class="sku-extend-btn" @click="openSku(v.id)">展开</div>
							</div>
							<p class="field-row"><span class="field-label">操作人</span><span class="field-value">{{ v.operater || '-' }}</span></p>
							<p class="field-row"><span class="field-label">入库时间</span><span class="field-value">{{ v.createtime_text || '-' }}</span></p>
							<p class="field-row field-remark"><span class="field-label">备注</span><span class="field-value">{{ v.remark || '-' }}</span></p>
            </div>
          </div>
        </van-list>
      </div>
      
    </div>
  </div>
</template>

<script>
import StHeader from "@/components/layout/Header.vue";
import StSelect from "@/components/Select.vue";
import StFormItem from "@/components/formItem.vue";
export default {
  components: {
		"st-header": StHeader,
		StSelect,
		StFormItem
	},
  props: {},
  data() {
    return {
			loading: false,
			finished: false,
			page: 1,
			skuShowAll: {},
			showSearch: false,
			searchData: {
				order_code: "",
				sku: "",
				id: "",
			},
			stlist: [],
    };
  },
  watch: {},
  computed: {},
  methods: {
    async get_st_list(e) {
      this.stlist = [];
      this.onLoad();
    },
    init() {
			this.searchData.id = this.$route.params.id;
			this.get_st_list();
    },
    // 分页
    async onLoad() {
			this.loading = true;
			let params = this.searchData;
			params['page'] = this.page;
      let result = await this.$post(this.$api.stGetPurchaseStorageLog, params);
			setTimeout(() => {}, 2000)
      if (result.data.length == 0) return (this.finished = true);
			result.data.forEach((item) => {
				if (item.list.length > 3) {
					this.skuShowAll[item.id] = false;
				} else {
					this.skuShowAll[item.id] = true;
				}
			});
      // 进行操作
      this.stlist.push(...result.data);
      // 操作完成
			this.page += 1;
      this.loading = false;
    },
    
    goUrl(url) {
      this.$router.push(url);
      return;
    },
    
    onSearch(val) {
      this.stlist = [];
      this.finished = false;
      this.page = 1;
      this.onLoad();
    },
    onCancel() {},
    // 关键字搜索
    submitKeyword() {
      this.stlist = [];
      this.finished = false;
      this.page = 1;
      this.onLoad();
    },
		// 展开sku列表
		openSku(id) {
			this.$set(this.skuShowAll, id, true);
			this.$forceUpdate();
		},
    getDetailRoute(item) {
      const purchaseOrderId = item && item.purchase_order_id ? item.purchase_order_id : '';
      if (purchaseOrderId) {
        return `/purchase/info/${purchaseOrderId}`;
      }
      // 兜底：避免跳到错误的销售详情页造成空白
      return '/purchase/list/0';
    }
  },
  created() {
    this.init();
    window.h5sdk && window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "入库记录" });
    });
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
div {
	box-sizing: border-box;
}
.search-icon-span .van-icon {
	font-size: 24px!important;
	color: #1a89fa;
	margin: 8px 12px;
	font-weight: 900;
}
.keyword {
  position: relative;
	top: 0;
  width: 100%;
  z-index: 1;
  background-color: transparent;
  padding-top: 0;
  padding-bottom: 0;
  margin-bottom: 0;
	
	::v-deep .st-select div[data-readonly='1'] .van-field {
		background-color: white;
	}
	
	::v-deep .st-select .van-field {
		box-shadow: none;
		border-radius: none;
	}
}

.keyword-form {
  margin: 0 12px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: none;
}

.keyword-collapsed {
  margin: 0 12px;
  height: 36px;
  border-radius: 8px;
  background: #fff;
  color: #8b95a7;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  box-shadow: none;
  border: 1px solid #eceff5;
}

.keyword-toggle-wrap {
  text-align: center;
  margin-top: 2px;
}

.keyword-toggle-line {
  margin: 0 12px;
  border-top: 1px solid #d8dce5;
  height: 10px;
  position: relative;
}

.keyword-toggle-btn {
  color: #8a93a3 !important;
  font-size: 18px;
  font-weight: 700;
  display: inline-block;
  padding: 0 14px;
  background-color: #eef1f6;
  position: relative;
  top: -9px;
  line-height: 20px;
  border-radius: 10px;
}
/* 2行input start */
.tab-content-list {
  padding-top: 0;
	position: relative;
	top:0;
	
	.st-list {
		margin: 12px 16px;
		border-radius: 10px;
	}
}

/* 2行input  end */

.st-list-bottom-diy {
  display: flex;
}
.st-list-bottom-diy .st-diyl-btn {
  background: #00baad;
  border-radius: 5px;
  flex: 1;
  margin-right: 8px;
}
.st-list-bottom-diy .st-diyl-btn.active {
  background: #677588;
}
.st-list-bottom-diy .st-diyr-btn {
  background: #3c8dbc;
  border-radius: 5px;
  flex: 1;
  margin-left: 8px;
}
.st-diyl-btn.checkBy {
  background-color: #677588;
}

.sku-list-box {
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	padding: 8px 0;
	border-bottom: 1px dashed #edf0f5;
	.sku-info {
		flex: 1;
		min-width: 0;
	}
	.sku-text {
		font-size: 16px;
		line-height: 1.45;
		color: #303133;
		word-break: break-word;
	}
	.sku-warehouse {
		font-size: 12px;
		line-height: 1.4;
		color: #8a6d3b;
		margin-top: 4px;
	}
	.outstocknum {
		color: #219ff3;
		font-size: 24px;
		font-weight: 600;
		padding-left: 12px;
		line-height: 1.2;
	}
}
.sku-extend-btn {
	display: none;
}
.sku-show-part {
	max-height: 120px;
	overflow: hidden;
	text-align: center;
	position: relative;
	.sku-extend-btn {
		display: block;
		position: absolute;
		bottom: 0px;
		width: 100%;
		font-size: 13px;
		color: #7d8799;
		background-color: #f0f2f7;
		border-radius: 3px;
		box-shadow: 0 1px 8px rgba(0, 0, 0, 0.08);
	}
}

.st-list-main {
  .field-row {
    display: flex;
    align-items: flex-start;
    margin: 8px 0;
    line-height: 1.55;
    color: #4b5565;
  }

  .field-label {
    width: 74px;
    flex-shrink: 0;
    color: #7b8392;
  }

  .field-label::after {
    content: "：";
  }

  .field-value {
    flex: 1;
    color: #303133;
    word-break: break-word;
  }

  .field-remark .field-value {
    color: #616b7c;
  }
}
</style>
